import StaffBookings from "./staff";
import ParticipantBookings from "./participant";
import { useThemeContext } from "../../context/themeContext";

export default function Bookings() {
  const { theme } = useThemeContext();

  return <>{theme === "staff" ? <StaffBookings /> : <ParticipantBookings />}</>;
}
